const enLang = {
  header: {
    setting: 'Set up',
    fullScreen: 'Full screen',
    exitFullscreen: 'Exit Full Screen',
    userCenter: 'Personal Center',
    logout: 'Sign out',
    langLabel: 'language',
    zhTip: 'Chinese',
    enTip: 'English',
    jaTip: 'Japanese',
    koTip: 'Korean'
  },
  home: {
    welcome: 'Welcome to use BiYi BMS Framework',
    versionDoc: 'New Version Document Description'
  },
  placeholderText: 'Please enter text...',
  placeholderDate: 'selection date',
  submitText: 'submit',
  cancelText: 'cancel',
  enterText: 'please enter',
  searchText: 'search',
  newText: 'new-build',
  editText: 'edit',
  deleteText: 'delete',
  operateText: 'operate',
  deletePopTip: 'Are you sure delete this data?',
  successText: 'Submit successfully',
  errorText: 'Failure to submit',
  holder: 'please enter',
  required: 'required'
}

export default enLang
